import { useState } from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import moment from 'moment'

import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Typography
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 20
  },
  content: {
    padding: 0
  },
  heading: {
    padding: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}))

const headCells = [
  { id: 'date', label: 'Data', numeric: false },
  { id: 'sellerName', label: 'Vendedor', numeric: false },
  { id: 'reason', label: 'Motivo', numeric: false },
  { id: 'justification', label: 'Justificativa', numeric: false }
]

function descendingComparator(a, b, orderBy) {
  const valA = orderBy === 'date' ? new Date(a[orderBy]).getTime() : a[orderBy]
  const valB = orderBy === 'date' ? new Date(b[orderBy]).getTime() : b[orderBy]
  if (valB < valA) return -1
  if (valB > valA) return 1
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilized = array.map((el, index) => [el, index])
  stabilized.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilized.map(el => el[0])
}

export default function JustificationsTable({ items = [] }) {
  const classes = useStyles()
  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('date')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filteredItems = items.filter(row => row.justification)

  const sorted = stableSort(filteredItems, getComparator(order, orderBy))
  const paginated = sorted.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  )

  return (
    <Card className={classes.root}>
      <Typography variant='h5' className={classes.heading}>
        Justificativas de não compra - por vendedor
      </Typography>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <TableContainer>
            <Table aria-label='justifications table'>
              <TableHead>
                <TableRow>
                  {headCells.map(cell => (
                    <TableCell
                      key={cell.id}
                      sortDirection={orderBy === cell.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === cell.id}
                        direction={orderBy === cell.id ? order : 'asc'}
                        onClick={e => handleRequestSort(e, cell.id)}
                      >
                        {cell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginated.length > 0 ? (
                  paginated.map((row, index) => (
                    <TableRow hover tabIndex={-1} key={row.id || index}>
                      <TableCell>
                        {moment(row.date).format('DD/MM/YYYY HH:mm')}
                      </TableCell>
                      <TableCell>{row.sellerName}</TableCell>
                      <TableCell>{row.reason}</TableCell>
                      <TableCell>{row.justification}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                      Nenhuma justificativa encontrada no período.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </CardContent>
      {filteredItems.length > 0 && (
        <CardActions className={classes.actions}>
          <TablePagination
            component='div'
            count={filteredItems.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 100]}
            labelRowsPerPage='Itens por página'
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} de ${count}`
            }
          />
        </CardActions>
      )}
    </Card>
  )
}

JustificationsTable.propTypes = {
  items: PropTypes.array
}
